(ns app.domain.template.model
  (:require [schema-tools.core :as st]
            [schema.core :as s]))

(s/defschema SnippetVar
  (st/merge
    {:variable-name s/Str}
    (st/optional-keys
      {:snippet? s/Bool})))

(def address-placeholders ["street-name" "address-number" "city" "unit-type" "unit-number" "unit-type-and-number"])

(def party-placeholders ["person-name" "person-company" "person-address" "person-phone-number" "person-email" "person-roles"])

(def workspace-header-placeholders ["header" "workspace-id" "municipal-case-number"])

(def workspace-footer-placeholders ["created-date" "assignee" "date-generated"])

(def unit-placeholder-variables
  "Template variables (added in WIN-4988) that are gated by `:feature-flag.id/property-db-units`."
  (set address-placeholders))

(defn as-variable-name-maps
  "Convert a sequence of plain placeholder strings into the [{:variable-name \"foo\"}]"
  [placeholders]
  (mapv (fn [p] {:variable-name p}) placeholders))

(defn- variable-name [v]
  (if (map? v) (:variable-name v) v))

(defn filter-unit-placeholders
  "Hide unit-related placeholders when `:feature-flag.id/property-db-units` is off."
  [variables feature-flags]
  (if (contains? feature-flags :feature-flag.id/property-db-units)
    variables
    (let [drop? (comp unit-placeholder-variables variable-name)
          kept  (remove drop? variables)]
      (if (set? variables) (set kept) kept))))

(s/defschema SnippetConfig
  (st/merge
    {:template-reference s/Str
     :pdf-title          s/Keyword}
    (st/optional-keys
      {:db-reference                s/Keyword
       :fragment-reference          s/Keyword
       :template-variables          [(s/cond-pre SnippetVar s/Str)]
       :children                    [] ; adding sub-components at snippet-level not yet implemented for nested snippets
       :snippets                    [(s/recursive #'SnippetConfig)]
       :display-html-editor         s/Bool
       :hide-html-editor?           s/Bool
       :replace-placeholder-fn      (s/pred ifn?)
       :entity->snippet-entities-fn (s/pred ifn?)})))
